import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import HelpIcon from "@mui/icons-material/Help";
import ReactTooltip from "react-tooltip";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const classes = {
  lblGraph: {
    backgroundColor: "#F5F5F5",
    color: "#155BCB",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    borderRadius: 3,
    height: "35px",
    display: "flex",
    alignItems: "center",
    padding: 10,
  },
  graph: {
    border: "1px solid #D1CCCC",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    height: "300px",
  },
  gridLabel: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: 5,
  },
  helpText: {
    marginTop: -4,
    cursor: "pointer",
  },
};

const stepStatus = ["Abertura", "Homologação", "Execução", "Conclusão"];
const mapColors = {
  Abertura: "#f24822",
  Homologação: "#5ea1cf",
  Execução: "#a7db64",
  Conclusão: "#796d33",
};

// Mapeamento do campo status para a etapa correspondente
function getStepStatusFromStatus(status) {
  const statusMapping = {
    // Abertura
    "Novo": "Abertura",
    // Homologação
    "Em análise": "Homologação",
    "Aguardando Informação": "Homologação",
    "Autorizado/Aprovado": "Homologação",
    "Solução de longo prazo / Sugestão de projeto": "Homologação",
    // Execução
    "Em execução": "Execução",
    "Encaminhado para o executor": "Execução",
    "Notificado para providências": "Execução",
    // Conclusão
    "Resolvido": "Conclusão",
    "Indeferido": "Conclusão",
    "Respondido": "Conclusão",
    "Detecção incorreta": "Conclusão"
  };
  return statusMapping[status] || null;
}

export default function StatusOfOccurrences({ occurrences, months }) {
  const [dataBar, setDataBar] = useState({
    labels: [],
    datasets: [],
  });

  const optionsStackbar = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  useEffect(() => {
    const labels = months.reduce((array, month) => {
      if (month.isActive) array.push(month.name);
      return array;
    }, []);

    //Cada item dos vetores representa um mês.
    const data = stepStatus.reduce((acc, curr) => {
      acc[curr] = new Array(12).fill(0);
      return acc;
    }, {});

    for (let i = 0, n = occurrences.length; i < n; i++) {
      const occurrence = occurrences[i];
      const createdAt = moment(occurrence.createdAt);
      const step = getStepStatusFromStatus(occurrence.status);
      if (step) {
        data[step][createdAt.get("month")] += 1;
      }
    }

    //Remove os meses não selecionados
    const dataFiltred = stepStatus.reduce((acc, curr) => {
      acc[curr] = [];
      return acc;
    }, {});

    const monthsNames = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ];

    for (let i = 0; i < 12; i++) {
      if (labels.includes(monthsNames[i])) {
        stepStatus.forEach((statusName) => {
          try {
            dataFiltred[statusName].push(data[statusName][i]);
          } catch (error) { }
        });
      }
    }

    const datasets = stepStatus.map((statusName) => {
      return {
        label: statusName,
        data: dataFiltred[statusName],
        backgroundColor: mapColors[statusName],
      };
    });

    setDataBar({
      labels,
      datasets: datasets,
    });
  }, [occurrences, months, stepStatus]);

  return (
    <div id="status-ocurrencies-dashboard" style={{ width: "100%" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} style={classes.lblGraph}>
        <div style={classes.gridLabel}>
          <div>Status da Ocorrência:</div>
          <div style={classes.helpText}>
            <ReactTooltip id="proportion-info" className="popup" />
            <HelpIcon
              style={{ color: "#a1a5ab" }}
              fontSize="small"
              data-for="proportion-info"
              data-place="bottom"
              data-tip="Gráfico de barras que apresenta a relação entre os estados no dercorrer dos meses."
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} style={classes.graph}>
        <Bar data={dataBar} options={optionsStackbar} />
      </Grid>
    </div>
  );
}
